// extracted by mini-css-extract-plugin
export default {"warpper":"index_warpper__nTxI0","inner":"index_inner__9mZFw","icons":"index_icons__N9xD3","nav":"index_nav__u5cFC","badges":"index_badges__Oa-js"};